import React from 'react';
import { Container, Grid, Typography, Card, CardContent, Box } from '@mui/material';

const HowItWorksSection = ({ t }) => (
    <Box sx={{ padding: 4, pb: 15, background: '#fd66c4', borderTopLeftRadius: 75, borderTopRightRadius: 75 }}>
        <Container>
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h3" color='#fff' sx={{ fontSize: { xs: '2.125rem', sm: '3rem' }, mb: 5, fontWeight: 'bold', textAlign: 'center' }}>
                        {t('hiw_title')}
                    </Typography>
                </Grid>

                <Grid item xs={12} md={5} sx={{
                    marginTop: { xs: 4, md: 0 },
                    padding: '0!important',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: { xs: 'none', md: 'block' }
                }}>
                    <Box
                        alt="How it Works"
                        component="img"
                        src={require('../../assets/img/howitworks-image.webp')}
                        sx={{ maxHeight: '500px', maxWidth: '100%' }}
                    />
                </Grid>

                <Grid item xs={12} md={7}>
                    <Grid container spacing={2} justifyContent="center">
                        {["hiw_step1", "hiw_step2", "hiw_step3", "hiw_step4"].map((step, index) => (
                            <Grid item xs={12} sm={6} key={index}>
                                <Card
                                    sx={{
                                        background: 'rgb(89,71,166, 0.4)',
                                        borderRadius: 4,
                                        height: 230,
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}
                                >
                                    <CardContent>
                                        <Typography color='white' component="h4" variant="h6" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            {t(step)}
                                        </Typography>
                                    </CardContent>
                                    <Box
                                        sx={{
                                            flexGrow: 1,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <img
                                            alt={`How It Works - Step ${index + 1}`}
                                            src={require(`../../assets/img/howitworks/${index + 1}.webp`)}
                                            style={{ maxWidth: '60%' }}
                                        />
                                    </Box>
                                </Card>

                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    </Box>
);

export default HowItWorksSection;
